import AuthenticatedLayout from "@/Layouts/AuthenticatedLayout.vue";

const appRoutes = [
    {
        meta: {
            title: 'Login',
        },
        path: '/login',
        name: 'login',
        component: () => import('@/Views/Auth/LoginView.vue'),
    },
    {
        meta: {
            title: 'Password Recovery',
        },
        path: '/password-recovery',
        name: 'passwordRecovery',
        component: () => import('@/Views/Auth/PasswordRecoveryView.vue'),
    },
    {
        meta: {
            title: 'Reset Password',
        },
        path: '/password-reset/:token',
        name: 'passwordReset',
        component: () => import('@/Views/Auth/PasswordResetView.vue'),
    },
    {
        meta: {
            title: 'Logout',
        },
        path: '/logout',
        name: 'logout',
        component: () => import('@/Views/Auth/LogoutView.vue'),
    },
    {
        meta: {
            title: 'OAuth Callback',
        },
        path: '/oauth/callback',
        name: 'oauthCallback',
        component: () => import('@/Views/Auth/OAuthCallback.vue'),
    },
    {
        meta: {
            title: 'Short Link',
        },
        path: '/sl/:shortLinkCode',
        name: 'shortlink',
        component: () => import('@/Views/ShortLinks/ShortLinksView.vue'),
        props: true,
    },
    {
        meta: {
            title: 'Reset PIN',
        },
        path: '/app/reset-pin',
        name: 'resetPin',
        component: () => import('@/Views/ShortLinks/Views/PinResetView.vue'),
    },
    {
        meta: {
            title: 'Link Expired',
        },
        path: '/link-expired',
        name: 'linkExpired',
        component: () => import('@/Views/ShortLinks/Views/LinkExpiredView.vue'),
    },
    {
        path: '/',
        redirect: '/calendar', // Redirige automáticamente a /calendar*/
        component: AuthenticatedLayout, // Layout para rutas autenticadas
        children: [
            {
                meta: {
                    title: 'Calendar',
                    requiresAuth: true
                },
                path: '/calendar', 
                name: 'calendar',
                component: () => import('@/Views/Calendar/CalendarView.vue'),
            },
            {
                meta: {
                    title: 'Companies',
                    requiresAuth: true
                },
                path: '/companies', 
                name: 'companies',
                component: () => import('@/Views/Settings/Companies/CompaniesView.vue'),
            },
            
            {
                meta: {
                    title: 'Add Companies',
                    requiresAuth: true
                },
                path: '/companies/add',
                name: 'addCompanyForm',
                component: () => import('@/Views/Settings/Companies/CompanyFormView.vue'),
                props: true,
            },
            {
                meta: {
                    title: 'Entities',
                    requiresAuth: true
                },
                path: '/entities', 
                name: 'entities',
                component: () => import('@/Views/Settings/Entities/EntitiesView.vue'),
            },
            {
                meta: {
                    title: 'Add Entities',
                    requiresAuth: true
                },
                path: '/entities/add',
                name: 'addEntitieForm',
                component: () => import('@/Views/Settings/Entities/EntitiesFormView.vue'),
                props: true,
            },
            {
                meta: {
                    title: 'Edit Entities',
                    requiresAuth: true
                },
                path: '/entities/edit/:entityID',
                name: 'entityEdit',
                component: () => import('@/Views/Settings/Entities/EntitiesFormView.vue'),
                props: true,
            },
            {
                meta: {
                    title: 'Edit Companies',
                    requiresAuth: true
                },
                path: '/companies/edit/:companyId',
                name: 'editCompany',
                component: () => import('@/Views/Settings/Companies/CompanyFormView.vue'),
                props: true, 
            },
            {
                meta: {
                    title: 'Centers',
                    requiresAuth: true
                },
                path: '/centers', 
                name: 'Centers',
                component: () => import('@/Views/Settings/Centers/CentersView.vue'),
            },
            {
                meta: {
                    title: 'Add Center',
                    requiresAuth: true
                },
                path: '/centers/add',
                name: 'addCenterForm',
                component: () => import('@/Views/Settings/Centers/CenterFormView.vue'),
                props: true,
            },
            {
                meta: {
                    title: 'Centers',
                    requiresAuth: true
                },
                path: '/centers/edit/:centerId',
                name: 'editCenter',
                component: () => import('@/Views/Settings/Centers/CenterFormView.vue'),
                props: true,
            },
            {
                meta: {
                    title: 'Employees',
                    requiresAuth: true
                },
                path: '/employees', 
                name: 'Employees',
                component: () => import('@/Views/Settings/Employees/EmployeesView.vue'),
            },
            {
                meta: {
                    title: 'Employees',
                    requiresAuth: true
                },
                path: '/employees/add',
                name: 'addEmployee',
                component: () => import('@/Views/Settings/Employees/EmployeeFormView.vue'),
                props: true,
            },
            {
                meta: {
                    title: 'Employees',
                    requiresAuth: true
                },
                path: '/employees/edit/:employeeID',
                name: 'editEmployee',
                component: () => import('@/Views/Settings/Employees/EmployeeFormView.vue'),
                props: true,
            },
            {
                meta: {
                    title: 'Spaces',
                    requiresAuth: true
                },
                path: '/spaces', 
                name: 'Spaces',
                component: () => import('@/Views/Settings/Spaces/SpacesView.vue'),
            },
            {
                meta: {
                    title: 'Spaces',
                    requiresAuth: true
                },
                path: '/spaces/add',
                name: 'addSpace',
                component: () => import('@/Views/Settings/Spaces/SpaceFormView.vue'),
                props: true,
            },
            {
                meta: {
                    title: 'Spaces',
                    requiresAuth: true
                },
                path: '/spaces/edit/:employeeID',
                name: 'editSpace',
                component: () => import('@/Views/Settings/Spaces/SpaceFormView.vue'),
                props: true,
            },
            {
                meta: {
                    title: 'History Templates',
                    requiresAuth: true
                },
                path: '/history-templates', 
                name: 'Templates',
                component: () => import('@/Views/Settings/HistoryTemplates/HistoryTemplatesView.vue'),
            },
            {
                meta: {
                    title: 'Add History Template',
                    requiresAuth: true
                },
                path: '/history-templates/add/',
                name: 'historyTemplateAdd',
                component: () => import('@/Views/Settings/HistoryTemplates/HistoryTemplateFormView.vue'),
            },
            {
                meta: {
                    title: 'Edit History Template',
                    requiresAuth: true
                },
                path: '/history-templates/edit/:historyTemplateID',
                name: 'historyTemplateEdit',
                props: true, 
                component: () => import('@/Views/Settings/HistoryTemplates/HistoryTemplateFormView.vue'),
                
            },
            {
                meta: {
                    title: 'Warehouses',
                    requiresAuth: true
                },
                path: '/warehouses', 
                name: 'warehouses',
                component: () => import('@/Views/Settings/Warehouses/WarehousesView.vue'),
            },
            {
                meta: {
                    title: 'Currencies',
                    requiresAuth: true
                },
                path: '/currencies', 
                name: 'Currencies',
                component: () => import('@/Views/Settings/Currencies/CurrenciesView.vue'),
            },
            {
                meta: {
                    title: 'Vat Rates',
                    requiresAuth: true
                },
                path: '/vat-rates', 
                name: 'vatRates',
                component: () => import('@/Views/Settings/VatRates/VatRatesView.vue'),
            },
            {
                meta: {
                    title: 'Payment Methods',
                    requiresAuth: true
                },
                path: '/payment-methods', 
                name: 'paymentMethods',
                component: () => import('@/Views/Settings/PaymentMethods/PaymentMethodsView.vue'),
            },
            {
                meta: {
                    title: 'Cancellation Reasons',
                    requiresAuth: true
                },
                path: '/cancellation-reasons', 
                name: 'cancellationReasons',
                component: () => import('@/Views/Settings/CancellationReasons/CancellationReasonsView.vue'),
            },
            {
                meta: {
                    title: 'Informed Consents',
                    requiresAuth: true
                },
                path: '/informed-consents', 
                name: 'informedConsents',
                component: () => import('@/Views/Settings/InformedConsents/InformedConsentsView.vue'),
            },
            {
                meta: {
                    title: 'Add Informed Consents',
                    requiresAuth: true
                },
                path: '/informed-consents/add/',
                name: 'informedConsentAdd',
                component: () => import('@/Views/Settings/InformedConsents/InformedConsentsFormView.vue'),
            },
            {
                meta: {
                    title: 'Edit Informed Consents',
                    requiresAuth: true
                },
                path: '/informed-consents/edit/:informedConsentId',
                name: 'informedConsentEdit',
                props: true, 
                component: () => import('@/Views/Settings/InformedConsents/InformedConsentsFormView.vue'),
                
            },
            {
                meta: {
                    title: 'Due Dates',
                    requiresAuth: true
                },
                path: '/due-dates', 
                name: 'dueDates',
                component: () => import('@/Views/Settings/DueDates/DueDatesView.vue'),
            },
            {
                meta: {
                    title: 'Roles',
                    requiresAuth: true
                },
                path: '/roles', 
                name: 'roles',
                component: () => import('@/Views/Settings/Roles/RolesView.vue'),
            },
            {
                meta: {
                    title: 'Customers',
                    requiresAuth: true
                },
                path: '/customers', 
                name: 'customers',
                component: () => import('@/Views/Customers/Customers/CustomersView.vue'),
            },
            {
                meta: {
                    title: 'Customers Add',
                    requiresAuth: true
                },
                path: '/customers/create', 
                name: 'customersAdd',
                component: () => import('@/Views/Customers/Customers/CustomersFormView.vue'),
                props: true,
            },
            {
                meta: {
                    title: 'Edit Customers',
                    requiresAuth: true
                },
                path: '/customers/edit/:customerID',
                name: 'customersEdit',
                component: () => import('@/Views/Customers/Customers/CustomersFormView.vue'),
                props: true,
            },
            {
                meta: {
                    title: 'Appointments',
                    requiresAuth: true
                },
                path: '/customers-appointments', 
                name: 'appointments',
                component: () => import('@/Views/Customers/CustomersAppointments/CustomersAppointmentsView.vue'),
            },
            {
                meta: {
                    title: 'Customers Tags',
                    requiresAuth: true
                },
                path: '/customers-tags', 
                name: 'customersTags',
                component: () => import('@/Views/Customers/Tags/TagsView.vue'),
            },
            {
                meta: {
                    title: 'Customers Vouchers',
                    requiresAuth: true
                },
                path: '/customers-vouchers', 
                name: 'customersVouchers',
                component: () => import('@/Views/Customers/Vouchers/CutomersVouchersView.vue'),
            },
            {
                meta: {
                    title: 'Sessions Concluded',
                    requiresAuth: true
                },
                path: '/concluded-sessions', 
                name: 'concludedSessions',
                component: () => import('@/Views/Customers/SessionsConcluded/SessionsConcludedView.vue'),
            },
            {
                meta: {
                    title: 'Vouchers',
                    requiresAuth: true
                },
                path: '/vouchers', 
                name: 'vouchers',
                component: () => import('@/Views/Marketing/Vouchers/Vouchers/VouchersView.vue'),
            },
            {
                meta: {
                    title: 'Vouchers Series',
                    requiresAuth: true
                },
                path: '/vouchers-series', 
                name: 'vouchersSeries',
                component: () => import('@/Views/Marketing/Vouchers/VouchersSeries/VouchersSeriesView.vue'),
            },
            {
                meta: {
                    title: 'Vouchers Series Create',
                    requiresAuth: true
                },
                path: '/vouchers-series/create', 
                name: 'vouchersSeriesCreate',
                component: () => import('@/Views/Marketing/Vouchers/VouchersSeries/VouchersSeriesFormView.vue'),
            },
            {
                meta: {
                    title: 'Vouchers Series Edit',
                    requiresAuth: true
                },
                path: '/vouchers-series/edit/:voucherSerieId',
                name: 'vouchersSeriesEdit',
                component: () => import('@/Views/Marketing/Vouchers/VouchersSeries/VouchersSeriesFormView.vue'),
                props: true,
            },
            {
                meta: {
                    title: 'Annie Bot',
                    requiresAuth: true
                },
                path: '/annie-bot', 
                name: 'annie-bot',
                component: () => import('@/Views/Marketing/AnnieBot/AnnieBotView.vue'),
            },
            {
                meta: {
                    title: 'WhatsApp Campaigns',
                    requiresAuth: true
                },
                path: '/whatsapp-campaigns', 
                name: 'whatsapp-campaigns',
                component: () => import('@/Views/Marketing/WhatsApp/WhatsAppMarketingView.vue'),
            },
            {
                meta: {
                    title: 'Annie Bot Create',
                    requiresAuth: true
                },
                path: '/annie-bot/add', 
                name: 'annie-bot-create',
                component: () => import('@/Views/Marketing/AnnieBot/AnnieBotFormView.vue'),
            },
            {
                meta: {
                    title: 'Annie Bot Edit',
                    requiresAuth: true
                },
                path: '/annie-bot/edit/:annieBotID', 
                name: 'annie-bot-edit',
                component: () => import('@/Views/Marketing/AnnieBot/AnnieBotFormView.vue'),
                props: true, 
            },
            {
                meta: {
                    title: 'SMS Marketing',
                    requiresAuth: true
                },
                path: '/sms-marketing', 
                name: 'sms-marketing',
                component: () => import('@/Views/Marketing/SMS/SmsMarketingView.vue'),
            },
            {
                meta: {
                    title: 'SMS Marketing add',
                    requiresAuth: true
                },
                path: '/sms-marketing/add', 
                name: 'sms-marketing-add',
                component: () => import('@/Views/Marketing/SMS/SmsMarketingStep1View.vue'),
            },
            {
                meta: {
                    title: 'SMS Marketing step2',
                    requiresAuth: true
                },
                path: '/sms-marketing/add/step2', 
                name: 'sms-marketing-step2',
                component: () => import('@/Views/Marketing/SMS/SmsMarketingStep2View.vue'),
            },
            {
                meta: {
                    title: 'SMS Marketing step3',
                    requiresAuth: true
                },
                path: '/sms-marketing/add/step3', 
                name: 'sms-marketing-step3',
                component: () => import('@/Views/Marketing/SMS/SmsMarketingStep3View.vue'),
            },
            {
                meta: {
                    title: 'WhatsApp Marketing',
                    requiresAuth: true
                },
                path: '/whatsapp-marketing', 
                name: 'whatsapp-marketing',
                component: () => import('@/Views/Marketing/WhatsApp/WhatsAppMarketingView.vue'),
            },
            {
                meta: {
                    title: 'WhatsApp Marketing add',
                    requiresAuth: true
                },
                path: '/whatsapp-marketing/add', 
                name: 'whatsapp-marketing-add',
                component: () => import('@/Views/Marketing/WhatsApp/WhatsAppFormView.vue'),
            },
            {
                meta: {
                    title: 'WhatsApp Marketing edit',
                    requiresAuth: true
                },
                path: '/whatsapp-marketing/edit/:id', 
                name: 'whatsapp-marketing-edit',
                component: () => import('@/Views/Marketing/WhatsApp/WhatsAppFormView.vue'),
            },
            {
                meta: {
                    title: 'Services',
                    requiresAuth: true
                },
                path: '/services', 
                name: 'services',
                component: () => import('@/Views/Services/ServicesView.vue'),
            },
            {
                meta: {
                    title: 'Classes',
                    requiresAuth: true
                },
                path: '/classes', 
                name: 'classes',
                component: () => import('@/Views/Classes/ClassesView.vue'),
            },
            {
                meta: {
                    title: "Profile",
                    requiresAuth: true,
                },
                path: "/user/profile/:employeeID",
                name: "profile",
                component: () => import("@/Views/Profile/ProfileView.vue"),
                props: true, 
            },
            {
                meta: {
                    title: 'System Settings',
                    requiresAuth: true
                },
                path: '/system-settings', 
                name: 'system_settings',
                component: () => import('@/Views/Settings/System/SystemSettingsView.vue'),
            },
            {
                meta: {
                    title: 'Charges',
                    requiresAuth: true
                },
                path: 'charges', 
                name: 'business_charges',
                component: () => import('@/Views/Business/Charges/ChargesView.vue'),
            },
            {
                meta: {
                    title: 'Invoices',
                    requiresAuth: true
                },
                path: 'invoices', 
                name: 'business_invoices',
                component: () => import('@/Views/Business/Invoices/InvoicesView.vue'),
            },
            {
                meta: {
                    title: 'Generate Charges & Invoices',
                    requiresAuth: true
                },
                path: '/business/generate/:type', 
                name: 'generate_charges_invoices',
                component: () => import('@/Views/Business/Generator/ChargeInvoiceGeneratorView.vue'),
                props: true, 
            },
            {
                meta: {
                    title: 'Edit Charges & Invoices',
                    requiresAuth: true
                },
                path: '/business/edit/:type/:invoice_charge_id', 
                name: 'edit_charges_invoices',
                component: () => import('@/Views/Business/Generator/ChargeInvoiceGeneratorView.vue'),
                props: true, 
            },
            {
                meta: {
                    title: 'Cash Clousures',
                    requiresAuth: true
                },
                path: 'cash-clousures', 
                name: 'cash_clousures',
                component: () => import('@/Views/Business/CashClousures/CashClousuresView.vue'),
            },
            {
                meta: {
                    title: 'Business Report',
                    requiresAuth: true
                },
                path: '/reports/business', 
                name: 'report_business',
                component: () => import('@/Views/Reports/Business/BusinessReportView.vue'),
            },
            {
                meta: {
                    title: 'Cancellations Report',
                    requiresAuth: true
                },
                path: '/reports/cancellations', 
                name: 'report_cancellations',
                component: () => import('@/Views/Reports/Cancellations/CancellationsReportView.vue'),
            },
            {
                meta: {
                    title: 'NPS Report',
                    requiresAuth: true
                },
                path: '/reports/nps', 
                name: 'report_nps',
                component: () => import('@/Views/Reports/Nps/NpsReportView.vue'),
            },
            {
                meta: {
                    title: 'Charges Invoices Report',
                    requiresAuth: true
                },
                path: '/reports/charges-invoices', 
                name: 'charges_invoices',
                component: () => import('@/Views/Reports/ChargesInvoices/ChargesInvoicesReportView.vue'),
            },
            {
                meta: {
                    title: 'Resources Capacity',
                    requiresAuth: true
                },
                path: '/reports/resources-capacity', 
                name: 'resources_capacity',
                component: () => import('@/Views/Reports/ResourcesCapacity/ResourcesCapacityReportView.vue'),
            },
            {
                meta: {
                    title: 'Attendance Report',
                    requiresAuth: true
                },
                path: '/reports/attendance', 
                name: 'report_attendance',
                component: () => import('@/Views/Reports/Attendance/AttendanceReportView.vue'),
            },
            {
                meta: {
                    title: 'Vacations Report',
                    requiresAuth: true
                },
                path: '/reports/vacations',
                name: 'report_vacations',
                component: () => import('@/Views/Reports/Vacations/VacationsReportView.vue'),
            },
            {
                meta: {
                    title: 'Appointments Report',
                    requiresAuth: true
                },
                path: '/reports/appointments',
                name: 'report_appointments',
                component: () => import('@/Views/Reports/Appointments/AppointmentsReportView.vue'),
            },
            {
                meta: { title: 'App Report', requiresAuth: true },
                path: '/reports/bot',
                name: 'report_app',
                component: () => import('@/Views/Reports/App/AppReportView.vue'),
            },
            {
                meta: {
                    title: 'Employees Report',
                    requiresAuth: true
                },
                path: '/reports/employees', 
                name: 'report_employees',
                component: () => import('@/Views/Reports/Employees/EmployeesReportView.vue'),
            },
            {
                meta: {
                    title: 'Subsciption Report',
                    requiresAuth: true
                },
                path: '/reports/subscription', 
                name: 'report_subscription',
                component: () => import('@/Views/Reports/Subscription/SubscriptionReportView.vue'),
            },
            {
                meta: {
                    title: 'Expenses Categories',
                    requiresAuth: true
                },
                path: '/expenses-categories', 
                name: 'expenses_categories',
                component: () => import('@/Views/Settings/ExpensesCategories/ExpensesCategoriesView.vue'),
            },
            {
                meta: {
                    title: 'Expenses View',
                    requiresAuth: true
                },
                path: '/expenses',
                name: 'expenses',
                component: () => import('@/Views/Business/Expenses/ExpensesView.vue'),
            },

            {
                meta: {
                    title: 'Purchases View',
                    requiresAuth: true
                },
                path: '/reports/purchases',
                name: 'reports_purchases',
                component: () => import('@/Views/Reports/Purchases/PurchasesView.vue'),
            },
            {
                meta: {
                    title: 'Registros View',
                    requiresAuth: true
                },
                path: '/settings/logs',
                name: 'settings_logs',
                component: () => import('@/Views/Settings/Logs/LogsView.vue'),
            },
            {
                meta: {
                    title: 'WhatsApp Events',
                    requiresAuth: true
                },
                path: '/settings/whatsapp/events',
                name: 'settings_whatsapp_events',
                component: () => import('@/Views/Settings/WhatsApp/WhatsAppEventsView.vue'),
            },
            {
                meta: {
                    title: 'Historial Recordatorios',
                    requiresAuth: true
                },
                path: '/whatsapp-reminders-logs',
                name: 'whatsapp_reminders_logs',
                component: () => import('@/Views/Reports/Reminders/RemindersLogView.vue'),
            },
            {
                meta: {
                    title: 'Quotations',
                    requiresAuth: true
                },
                path: '/quotations',
                name: 'business_quotations',
                component: () => import('@/Views/Business/Quotations/QuotationsView.vue'),
            }
            ,
            {
                meta: {
                    title: 'Documentos',
                    requiresAuth: true
                },
                path: '/documents',
                name: 'documents',
                component: () => import('@/Views/Settings/Documents/DocumentsView.vue'),
            },
            {
                meta: {
                    title: 'Categorias de documentos',
                    requiresAuth: true
                },
                path: '/documents-categories',
                name: 'documents_categories',
                component: () => import('@/Views/Settings/DocumentsCategories/DocumentsCategoriesView.vue'),
            },
            {
                meta: {
                    title: 'Categorias de productos',
                    requiresAuth: true
                },
                path: '/categories',
                name: 'products_categories',
                component: () => import('@/Views/Products/ProductsCategories/ProductsCategoriesView.vue'),
            },
            {
                meta: {
                    title: 'Marcas de productos',
                    requiresAuth: true
                },
                path: '/brands',
                name: 'products_brands',
                component: () => import('@/Views/Products/Brands/BrandsView.vue'),
            },
            {
                meta: {
                    title: 'Atributos de productos',
                    requiresAuth: true
                },
                path: '/attributes',
                name: 'products_attributes',
                component: () => import('@/Views/Products/Attributes/ProductsAttributesView.vue'),
            },
            {
                meta: {
                    title: 'Productos',
                    requiresAuth: true
                },
                path: '/products',
                name: 'products',
                component: () => import('@/Views/Products/Products/ProductsView.vue'),
            },
            {
                meta: {
                    title: 'Nuevo producto',
                    requiresAuth: true
                },
                path: '/products/create',
                name: 'products-create',
                component: () => import('@/Views/Products/Products/ProductForm.vue'),
            },
            {
                meta: {
                    title: 'Editar producto',
                    requiresAuth: true
                },
                path: '/products/edit/:id',
                name: 'products-edit',
                component: () => import('@/Views/Products/Products/ProductForm.vue'),
            },
            {
                meta: {
                    title: 'Marketplace',
                    requiresAuth: true
                },
                path: '/marketplace',
                name: 'marketplace',
                component: () => import('@/Views/Marketplace/MarketplaceView.vue'),
            },
            {
                meta: {
                    title: 'Custom Fields',
                    requiresAuth: true
                },
                path: '/custom-fields', 
                name: 'custom_fields',
                component: () => import('@/Views/Settings/CustomFields/CustomFieldsView.vue'),
            },
            {
                meta: {
                    title: 'Programs, vouchers and classes',
                    requiresAuth: true
                },
                path: '/reports/programs-vouchers-classes',
                name: 'reports_programs_vouchers_classes',
                component: () => import('@/Views/Reports/ProgramsVouchersClasses/ProgramsVouchersClassesReportView.vue'),
            },
            {
                meta: {
                    title: 'Client App Settings',
                    requiresAuth: true
                },
                path: '/client-app-settings',
                name: 'clientAppSettings',
                component: () => import('@/Views/Settings/ClientApp/ClientAppSettingsView.vue'),
                beforeEnter: async (to, from, next) => {
                    try {
                        const { default: marketplaceApi } = await import('@/services/api/marketplace/marketplace')
                        const response = await marketplaceApi.getApps()
                        const apps = response.data || response || []
                        const app = apps.find(a => a.package_name === 'com.zeeclip.customerapp')
                        if (app?.customer?.active) {
                            next()
                        } else {
                            next('/calendar')
                        }
                    } catch {
                        next('/calendar')
                    }
                },
            },
        ],
    }
];

export default appRoutes;